import React from 'react'
import PropTypes from 'prop-types'

import DropDownMenu from 'material-ui/DropDownMenu'
import TextField from 'material-ui/TextField'
import MenuItem from 'material-ui/MenuItem'

import { PhoneNumberUtils } from '@fibo-app/fibo-collab-shared'

export default class PhoneNumberInput extends React.Component {

  static propTypes = {
    phoneInfo: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    onPhoneInfoChanged: PropTypes.func.isRequired,
    onEnterPressed: PropTypes.func.isRequired
  }

  handleAreaSelectorChanged = (event, index, value) => {
    event.preventDefault()
    const valueInfo = value.split('#')
    this.props.onPhoneInfoChanged(
      Object.assign(this.props.phoneInfo, { countryCode: valueInfo[0], countryName: valueInfo[1] })
    )
  }

  handleNumberChanged = event => {
    event.preventDefault()
    this.props.onPhoneInfoChanged(
      Object.assign(this.props.phoneInfo, { number: event.target.value }))
  }

  handleKeyDown = event => {
    if (event.keyCode === 13) {
      this.props.onEnterPressed()
    }
  }

  encodeDropdownValue = (countryCode, countryName) => {
    return `${countryCode}#${countryName}`
  }

  render() {
    return (
      <div style={styles.container}>
        <div style={styles.inputContainer}>
          <div>
            <DropDownMenu
              labelStyle={styles.labelStyle}
              disabled={this.props.disabled}
              underlineStyle={{border: 'solid 1px #527da3'}}
              selectedMenuItemStyle={{color: 'black'}}
              iconButton={null}
              iconStyle={{ display: 'none' }}
              value={this.encodeDropdownValue(this.props.phoneInfo.countryCode, this.props.phoneInfo.countryName)}
              onChange={this.handleAreaSelectorChanged}>
              {
                PhoneNumberUtils.areaCodeList.map((value, index) =>
                  <MenuItem
                    key={index}
                    value={this.encodeDropdownValue(value.code, value.name)}
                    label={value.code}
                    primaryText={`${value.name} (${value.code})`} />
                )
              }
            </DropDownMenu>
          </div>
          <div>
            <TextField
              id={'phone-input'}
              disabled={this.props.disabled}
              style={{ marginBottom: 4, width: 170 }}
              inputStyle={styles.numberInput}
              floatingLabelFocusStyle={{ color: '#527da3' }}
              underlineFocusStyle={{ borderColor: '#527da3' }}
              underlineDisabledStyle={{ borderColor: '#527da3' }}
              onKeyDown={this.handleKeyDown}
              onChange={this.handleNumberChanged} />
          </div>
        </div>
        <div style={styles.enterText}>
          Enter your phone number to continue
        </div>
      </div>
    )
  }

}

const styles = {

  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },

  inputContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'center'
  },

  enterText: {
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 300,
    lineHeight: 1.43,
    color: '#4a4a4a',
    marginLeft: 20 // To center align with inputs above.
  },

  numberInput: {
    color: '#4a4a4a',
    fontSize: 24,
    fontWeight: 300,
    fontFamily: 'Roboto'
  },

  labelStyle: {
    color: '#527da3',
    lineHeight: '64px',
    textAlign: 'center',
    fontSize: 24,
    fontWeight: 300,
    paddingLeft: 32,
    paddingRight: 32
  }

}


// WEBPACK FOOTER //
// ./src/login/PhoneNumberInput.js